import type { NotificationWithType } from "@features/Notification/types/types";

export interface NotificationState {
  notifications: NotificationWithType[];
  loading: boolean;
  error: string | null;
  page: number;
  hasMore: boolean;
  unreadCount: number;

}

export const initialState: NotificationState = {
  notifications: [],
  loading: false,
  error: null,
  page: 1,
  hasMore: true,
  unreadCount: 0,
};
